var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9983 26L15.9139 28.1473C15.4251 28.4043 14.8205 28.2164 14.5635 27.7275C14.4611 27.5328 14.4258 27.3099 14.463 27.0931L15.243 22.5451L11.9387 19.3242C11.5432 18.9387 11.5351 18.3056 11.9206 17.9101C12.0741 17.7526 12.2753 17.6501 12.4929 17.6185L17.0594 16.9549L19.1016 12.817C19.346 12.3217 19.9456 12.1184 20.4409 12.3628C20.6381 12.4602 20.7977 12.6198 20.8951 12.817L22.9372 16.9549L27.5037 17.6185C28.0503 17.6979 28.429 18.2053 28.3495 18.7519C28.3179 18.9695 28.2154 19.1707 28.0579 19.3242L24.7536 22.5451L25.5337 27.0931C25.627 27.6375 25.2614 28.1544 24.7171 28.2478C24.5003 28.2849 24.2774 28.2496 24.0827 28.1473L19.9983 26Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9983 26L15.9139 28.1473C15.4251 28.4043 14.8205 28.2164 14.5635 27.7275C14.4611 27.5328 14.4258 27.3099 14.463 27.0931L15.243 22.5451L11.9387 19.3242C11.5432 18.9387 11.5351 18.3056 11.9206 17.9101C12.0741 17.7526 12.2753 17.6501 12.4929 17.6185L17.0594 16.9549L19.1016 12.817C19.346 12.3217 19.9456 12.1184 20.4409 12.3628C20.6381 12.4602 20.7977 12.6198 20.8951 12.817L22.9372 16.9549L27.5037 17.6185C28.0503 17.6979 28.429 18.2053 28.3495 18.7519C28.3179 18.9695 28.2154 19.1707 28.0579 19.3242L24.7536 22.5451L25.5337 27.0931C25.627 27.6375 25.2614 28.1544 24.7171 28.2478C24.5003 28.2849 24.2774 28.2496 24.0827 28.1473L19.9983 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon1);
export default __webpack_public_path__ + "static/media/cardIcon1.dcac13a24e6afb96676f55ba6831d416.svg";
export { ForwardRef as ReactComponent };